module.exports = __webpack_public_path__ + "img/width-wide@2x.df95fa7.jpg";